export default __webpack_public_path__ + "static/media/icons8-instagram.89b88306.svg";